<fgb-navigation-indicator></fgb-navigation-indicator>
<fgbcl-notification-toast></fgbcl-notification-toast>

<ng-container>
  <fgb-mobile-nav-menu
    *ifScreenSize="screenType.Mobile"
    [isHomePage]="isHomePage"
    [isTertiary]="isTertiary"
    [isWallet]="isWallet"
    [isWalletItem]="isWalletItem"
    [isPurchaseSuccessPage]="isPurchaseSuccessPage"
    [isClaimedPage]="isClaimedPage"
    [isCampaignPage]="isCampaignPage"
    [isCheckOut]="isCheckOut"
    [notDisplayNav]="isRewardsItem || isScorecardPage"
    [title]="title"
  ></fgb-mobile-nav-menu>
</ng-container>

<ng-container>
  <fgb-nav-bar *ifScreenSize="screenType.Desktop"></fgb-nav-bar>
</ng-container>

<div id="main">
  <router-outlet></router-outlet>
</div>

<fgb-footer></fgb-footer>
